export default __webpack_public_path__ + "static/media/nesto_secure_logo_fr.17fd5293.png";